import { CustomizedSwitch } from "@components/customized/switch";
import styled from "@emotion/styled";
import { Box, Switch, SwitchProps, TextField, Typography } from "@mui/material";
import { CSSProperties } from "react";
import { Control, Controller, FieldValues } from "react-hook-form";

const LabelNameBox = styled(Box)(() => ({
  display: "flex",
  width: '30%'
}));

export const FormSwitch = (props: {
  name: string;
  control: Control<FieldValues | any, any>;
  label: string;
  uneditable?: boolean;
  sx?: CSSProperties;
}) => {
  return (
    <Controller
      name={props.name}
      control={props.control}
      render={({ field: { onChange, value } }) =>
        props.uneditable ? (
          <Typography sx={{ ...props.sx }}>{value ?? ""}</Typography>
        ) : (
          <Box
            sx={{
              flexDirection: "row",
              display: "flex",
              width: "100%",
              alignItems: "flex-end",
              height: "40px",
              marginRight: "30px",
              marginBottom: "10px",

            }}
          >
            <LabelNameBox>
              <Typography variant="h6" color="info">
                {props.label} :{" "}
              </Typography>
            </LabelNameBox>
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "flex-start",
                width: "40%",
                gap: "16px"
              }}
            >
              <CustomizedSwitch 
                  size='small'
                  onChange={onChange}
                  checked={value}
              />
              <Typography variant="h6" color="info">{value ? "Enable" : "Disable"}</Typography>
            </Box>
            
          </Box>
        )
      }
    />
  );
};
